'use strict';

$('.newsletter-signup #addtoemaillist').on('change', function () {
    if ($(this).is(':checked')) {
        $('.button-and-terms .error-check-optin').addClass('d-none');
    } else {
        $('.button-and-terms .error-check-optin').removeClass('d-none');
    }
});

$(document).on('submit', 'form.newsletter-signup', function (e) {
    e.preventDefault();
    // Call AJAX to save data when the form is valid
    $.spinner().start();
    var $form = $('.newsletter-signup');
    $.ajax({
        url: $form.attr('action'),
        method: 'POST',
        // dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (data.success) {
                $('.newsletter-signup').addClass('d-none');
                $('.msg-success').removeClass('d-none');
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});